const configuredVersion = Number(process.env.REACT_APP_RECEIPT_UI_VERSION ?? 1);

export const RECEIPT_UI_VERSION = configuredVersion === 2 ? 2 : 1;

export const RECEIPT_IMAGE_ACTIONS_ENABLED = ['1', 'true', 'yes', 'y'].includes(
  String(process.env.REACT_APP_RECEIPT_IMAGE_ACTIONS_ENABLED || '').trim().toLowerCase(),
);

